import React from 'react';
import clickSound from '../assets/sounds/click.mp3'; // تأكد من المسار حسب مكان الصوت

const arabicLetters = [
  'أ', 'ب', 'ت', 'ث', 'ج', 'ح', 'خ', 'د', 'ذ', 'ر',
  'ز', 'س', 'ش', 'ص', 'ض', 'ط', 'ظ', 'ع', 'غ', 'ف',
  'ق', 'ك', 'ل', 'م', 'ن', 'هـ', 'و', 'ي'
];

const LetterGrid = ({ onLetterSelect, usedLetters }) => {
  const clickAudio = new Audio(clickSound);

  const handleClick = (letter) => {
    if (!usedLetters.includes(letter)) {
      clickAudio.play();
      onLetterSelect(letter);
    }
  };

  return (
    <div className="grid grid-cols-6 gap-3 p-4 justify-center">
      {arabicLetters.map((letter, i) => (
        <button
          key={i}
          onClick={() => handleClick(letter)}
          disabled={usedLetters.includes(letter)}
          className={`letter-button w-14 h-14 flex items-center justify-center text-xl font-bold 
            ${usedLetters.includes(letter)
              ? 'bg-gray-300 text-gray-600'
              : 'bg-yellow-300 hover:bg-yellow-400'}`}
          
        >
          {letter}
        </button>
      ))}
    </div>
  );
};

export default LetterGrid;
